import React, { useMemo, useState } from 'react';
import { Attachment, AttachmentObject } from '@eduact/ed-components';
import {
	imageTypes,
	docsTypes,
} from '@eduact/ed-components/DataDisplay/Attachment';
import { createTheme, ThemeProvider } from '@eduact/student-theme';
import { FlexLayout } from '@eduact/ed-system';
import { Dialog } from '@mui/material';
import { openAttachment, parseAttachmentAnswer } from '@ContentManagement/attachmentAnswer';
import { Unreadable } from '@ContentManagement/Unreadable';
type Props = {
	answer: string;
};

const theme = createTheme({}) as any;
const AnswerAttachments: React.VoidFunctionComponent<Props> = ({ answer }) => {
	const { attachments, unreadable } = useMemo(
		() => parseAttachmentAnswer(answer),
		[answer]
	);

	const [isOpen, setIsOpen] = useState(false);
	const [attachment, setAttachment] = useState<AttachmentObject | undefined>();
	const handleOpenAttachment = (attachment: AttachmentObject) => {
		if (!imageTypes.includes(attachment.type) && attachment.type !== 'pdf') {
			openAttachment(attachment.url);
			return;
		}
		setAttachment(attachment);
		setIsOpen(true);
	};
	const handleCloseAttachment = () => {
		setAttachment(undefined);
		setIsOpen(false);
	};
	return (
		<ThemeProvider theme={theme as any}>
			<Dialog onClose={handleCloseAttachment} maxWidth="xl" open={isOpen}>
				<>
					{attachment && (
						<div>
							{imageTypes.includes(attachment.type) && (
								<img src={attachment.url} alt="" />
							)}
							{docsTypes.includes(attachment.type) && (
								<object
									style={{ width: '90vw', height: '90vh' }}
									data={attachment.url}
									datatype="application/pdf"
								>
									<iframe
										width={'100%'}
										height={'100%'}
										src={attachment.url}
										title="Pdf"
									></iframe>
								</object>
							)}
						</div>
					)}
				</>
			</Dialog>
			<FlexLayout gridGap={'1rem'} flexWrap="wrap" alignItems="center">
				{attachments.map((attachment) => {
					return (
						<Attachment
							key={attachment.url}
							onClick={handleOpenAttachment}
							type={attachment.type as AttachmentObject['type']}
							url={attachment.url}
							withDelete={false}
						/>
					);
				})}
				{unreadable && <Unreadable>Some attachments could not be read.</Unreadable>}
			</FlexLayout>
		</ThemeProvider>
	);
};

export default AnswerAttachments;

